( function( app ) {
  const COMPONENT = {
    init: function() {
      const updateMobileDropdownBottomOffset = () => {
        const ctaStack = document.querySelector( '.navigation-five__mobile-ctas' );
        const ctaHeight = ctaStack ? ctaStack.getBoundingClientRect().height : 0;
        const bottomOffset = ctaHeight > 0 ? ctaHeight + 32 : 32;

        document.documentElement.style.setProperty( '--navigationMobileDropdownBottomOffset', `${bottomOffset}px` );
      };

      updateMobileDropdownBottomOffset();
      window.addEventListener( 'resize', updateMobileDropdownBottomOffset );

      const mobileCtaStack = document.querySelector( '.navigation-five__mobile-ctas' );
      if ( mobileCtaStack && 'ResizeObserver' in window ) {
        this.mobileCtaObserver = new ResizeObserver( updateMobileDropdownBottomOffset );
        this.mobileCtaObserver.observe( mobileCtaStack );
      }

      const primaryNav = document.getElementById( 'primary-nav' );
      const closeOpenMobilePanels = () => {
        if ( window.innerWidth >= 1024 ) return;

        $( '.navigation-five .primary-menu-item__link.is-open, .navigation-five .easy-toggle-slide-toggle.is-open' ).trigger( 'click' );
      };

      if ( primaryNav ) {
        primaryNav.addEventListener( 'toggleAfter', () => {
          if ( !primaryNav.classList.contains( 'is-open' ) ) {
            closeOpenMobilePanels();
          }
        } );
      }

      if ( $( window ).width() > 1024 ) {
        // ADA close menu when focus shifts outside of it
        $( '.navigation-five .primary-navigation__panels' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          if ( !$menuItem.has( newFocus ).length ) {
            const $trigger = $menuItem.find( '.primary-menu-item__link.is-open' );
            if ( $trigger.length ) {
              $trigger.trigger( 'click' );
              newFocus.focus();
            }
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'navigation-five', COMPONENT );
} )( app );
